"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateIban = void 0;
/**
 * Generuje numer IBAN
 *
 * @export
 * @returns {string}
 */
function generateIban() {
    const ibanBase = `${getBankCodePart()}${getRandomPart()}`;
    const checksum = getChecksum(ibanBase);
    return `${checksum}${ibanBase}`;
}
exports.generateIban = generateIban;
const BANK_CODES = [
    '10902330',
    '15601081',
    '12402470',
    '10301016',
    '80630001',
    '10301410',
    '12401532',
    '10101023',
    '10100055',
    '10100000',
    '10101140'
];
/**
 * Zwraca część kodu banku
 *
 * @returns {string}
 */
function getBankCodePart() {
    return BANK_CODES[Math.floor(Math.random() * BANK_CODES.length)];
}
/**
 * Zwraca część losową
 *
 * @returns {string}
 */
function getRandomPart() {
    return new Array(4)
        .fill(undefined)
        .map(() => Math.floor(Math.random() * 10000)
        .toString()
        .padStart(4, '0'))
        .join('');
}
const PL_VALUE = 2521;
/**
 * Zwraca sumę kontrolną
 *
 * @param {string} ibanBase
 * @returns {string}
 */
function getChecksum(ibanBase) {
    const moduloResult = BigInt(`${ibanBase}${PL_VALUE}00`) % BigInt(97);
    return (98 - parseInt(moduloResult.toString())).toString().padStart(2, '0');
}
//# sourceMappingURL=generateIban.js.map